import React, { useState } from 'react';
import './Hero.css';

const IconMaterials = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const IconProfessional = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="6" r="3" />
    <path d="M4 22v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
    <path d="M8 12h.01M16 12h.01M12 12v4" />
  </svg>
);

const IconHome = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(1);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + 3) % 3);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % 3);
  };

  const features = [
    {
      icon: <IconMaterials />,
      title: 'Discover Materials',
      description: 'Direct access to quality construction materials'
    },
    {
      icon: <IconProfessional />,
      title: 'Hire Professionals',
      description: 'Connect with verified industry experts'
    },
    {
      icon: <IconHome />,
      title: 'Connect with Homeowners',
      description: 'Build relationships with new homeowners'
    }
  ];

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">One Platform. Multiple Solutions.</h1>
        <p className="hero-description">
          Source verified materials, collaborate with professionals, and connect directly with homeowners — all in one place.
        </p>
        <div className="hero-buttons">
          <button className="hero-btn hero-btn-primary">Join the Community</button>
          <button className="hero-btn hero-btn-secondary">Learn More</button>
        </div>
        <div className="feature-cards-wrapper">
          <div className="feature-cards">
            {features.map((feature, index) => (
              <div key={index} className={`feature-card ${index === activeIndex ? 'feature-card-highlight' : ''}`}>
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="hero-carousel-nav">
            <button type="button" aria-label="Previous" onClick={handlePrev}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
            </button>
            <button type="button" className="active" aria-label="Next" onClick={handleNext}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
